"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultPeopleGroupPage = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _base = babelHelpers.interopRequireWildcard(require("block/base"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _TabPanel = require("components/TabPanel");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp, _dec, _dec2, _class3, _descriptor5, _descriptor6, _descriptor7, _temp2;

var PeopleGroup = (_dec = (0, _decorators.alias)("content.type"), _dec2 = (0, _decorators.alias)("content.name"), (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(PeopleGroup, _Component2);

  function PeopleGroup() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, PeopleGroup);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(PeopleGroup)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "type", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "name", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(PeopleGroup, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(require(this.type)[this.name || 'default'], this.content);
    }
  }]);
  return PeopleGroup;
}(_react.Component), _temp2), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3));
exports.default = PeopleGroup;
var DefaultPeopleGroupPage = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(DefaultPeopleGroupPage, _Component);

  function DefaultPeopleGroupPage() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DefaultPeopleGroupPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DefaultPeopleGroupPage)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "background", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "header", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "tabs", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(DefaultPeopleGroupPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement("div", {
        className: _classList.default.join('block', 'stack', 'header-block', 'height-50vh', this.background && 'variable-background'),
        "data-landing-page-group": this.id,
        "data-block-type": "header",
        style: this.background ? _base.default.styleForBackgroundObject(this.background) : {}
      }, _react.default.createElement("div", {
        className: "spotlight-header"
      }, _react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, _react.default.createElement("h1", {
        className: "title"
      }, this.header.title), this.header.summary && _react.default.createElement("h2", null, this.header.summary)))), _react.default.createElement("div", {
        className: "block stack tabs"
      }, _react.default.createElement(_TabPanel.TabPanel, null, this.renderTabs())));
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      return this.tabs.map(function (tab, index) {
        return _react.default.createElement(tab.wrapper ? require(tab.wrapper.type)[tab.wrapper.name || 'default'] : _TabPanel.Tab, babelHelpers.objectSpread({
          title: tab.title,
          key: index
        }, tab.wrapper), _react.default.createElement(require(tab.type)[tab.name || 'default'], tab));
      });
    }
  }]);
  return DefaultPeopleGroupPage;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "background", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "header", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "tabs", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.DefaultPeopleGroupPage = DefaultPeopleGroupPage;